import { useState, useEffect } from 'react';

const SIZES = {
  sm: { container: 'w-10 h-10', spinner: 'w-4 h-4 border', icon: 'w-5 h-5', cdnWidth: 80 },
  md: { container: 'w-12 h-12', spinner: 'w-5 h-5 border-2', icon: 'w-6 h-6', cdnWidth: 96 },
  lg: { container: 'aspect-square', spinner: 'w-8 h-8 border-2', icon: 'w-12 h-12', cdnWidth: 400 },
};

function getCdnUrl(originalUrl, width) {
  if (!originalUrl) return null;
  if (!originalUrl.includes('.century21.pt/')) return originalUrl;

  const cleanUrl = originalUrl.split('?')[0];
  const params = new URLSearchParams({
    url: cleanUrl,
    w: String(width),
    q: '75',
    fm: 'webp',
  });
  return `/.netlify/images?${params.toString()}`;
}

export default function AgentPhoto({ src, alt, size = 'lg', className = '' }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setError(false);
  }, [src]);

  const s = SIZES[size] || SIZES.lg;
  const cdnSrc = getCdnUrl(src, s.cdnWidth);
  const showImage = src && !error;

  return (
    <div className={`${s.container} bg-gray-100 overflow-hidden relative ${className}`}>
      {showImage && !loaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className={`${s.spinner} border-[#B5985A] border-t-transparent rounded-full animate-spin`} />
        </div>
      )}

      {showImage && (
        <img
          src={cdnSrc}
          alt={alt}
          className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      )}

      {!showImage && (
        <img
          src="/person_placeholder.png"
          alt={alt || ''}
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
}
